import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isFinite from 'lodash/isFinite';

import * as shapes from '../../shapes';
import * as productsShapes from '../../../products/shapes';
import Money from '../../../common/money';

const Item = ({ item, selected, onClick, color, size, availableInventory }) => {
  const className = classnames(
    'c-product-select-btn u-position-relative',
    { 'is-active': selected,
      'c-product-select-btn--blue': color === 'blue',
      'c-product-select-btn--yellow': color === 'yellow',
      'c-product-select-btn--red': color === 'red',
      'c-product-select-btn--small': size === 'small',
    }
  );
  return (
    <li className="layout__item u-1/2 u-1/3-medium-and-up u-1/4-large-and-up">
      <button
        type="button"
        className={className}
        onClick={onClick}
        disabled={Number.isFinite(availableInventory) && availableInventory === 0}
      >
        <span className="o-center-content">
          <span className="c-product-select-btn__image" display-if={item.image}>
            <img src={item.image} alt="" />
          </span>
          <span className="c-product-select-btn__brand" display-if={item.brand}>
            {item.brand}
          </span>
          <span className="c-product-select-btn__name">
            {item.name}
          </span>
          <span className="c-product-select-btn__price" display-if={isFinite(item.value) || isFinite(item.price)}>
            <span display-if={item.type === 'percentage'}>{item.value}%</span>
            <Money display-if={item.type !== 'percentage'}>
              {item.price || item.value}
            </Money>
          </span>
          <div
            className={classnames('c-product-select-btn__stock', { 'u-co-red': !item.inventory })}
            display-if={Number.isFinite(item.inventory)}
          >
            Stock: {item.inventory}
          </div>
        </span>
      </button>
    </li>
  );
};
Item.propTypes = {
  item: PropTypes.oneOfType([
    productsShapes.product,
    shapes.service,
    shapes.discount,
  ]).isRequired,
  selected: shapes.flag,
  onClick: shapes.handler,
  color: shapes.string,
  size: shapes.string,
  availableInventory: PropTypes.number,
};
Item.defaultProps = {
  selected: false,
  onClick: () => null,
  color: '',
  size: '',
  availableInventory: null,
};

export default Item;
